import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"id":"app"}},[_c('div',{staticClass:"loader",class:_vm.getloadingState ? 'active' : ''},[_c('div',{staticClass:"loader-item"},[_c('div',{staticClass:"loader-wheel"}),_c('div',{staticClass:"loader-text"})])]),(_vm.getRequestAllFlag)?_c(VMain,[(_vm.getRequestAllFlag)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }